'use strict'

const API_BASE = 'https://tossp.yoooooo.com/index.php/index/private_universe_type_product/'

function normalizePrivateUniverseTypeProductLink (value) {
  const link = String(value || '').trim()
  return link === '无' ? '' : link
}

function createPrivateUniverseTypeProductApi (http, FormDataType) {
  const FormDataConstructor = FormDataType || FormData

  function unwrap (response) {
    const payload = response && response.data
    if (!payload || Number(payload.code) !== 200) {
      throw new Error(payload && payload.msg ? payload.msg : '请求失败')
    }
    return payload.data
  }

  function handleError (error) {
    const payload = error && error.response && error.response.data
    if (payload && payload.msg) {
      throw new Error(payload.msg)
    }
    throw error instanceof Error ? error : new Error('请求失败')
  }

  return {
    list () {
      return http.get(API_BASE + 'category_list')
        .then(unwrap)
        .catch(handleError)
    },

    update (input) {
      const formData = new FormDataConstructor()
      formData.append('stat_id', input.stat_id)
      formData.append('namech', input.namech)
      formData.append('img', input.img)
      formData.append('qiutibili', input.qiutibili)
      formData.append('apmg', input.apmg)
      formData.append(
        'real_speed',
        input.real_speed === undefined || input.real_speed === null ? '1' : input.real_speed
      )
      return http.post(API_BASE + 'update_item', formData)
        .then(unwrap)
        .catch(handleError)
    },

    remove (statId) {
      const formData = new FormDataConstructor()
      formData.append('stat_id', statId)
      return http.post(API_BASE + 'delete_item', formData)
        .then(unwrap)
        .catch(handleError)
    }
  }
}

export { createPrivateUniverseTypeProductApi, normalizePrivateUniverseTypeProductLink }



// WEBPACK FOOTER //
// ./src/api/privateUniverseTypeProduct.js